// extracted by mini-css-extract-plugin
export default {"page":"styles_page__AM7Bq","leftPanel":"styles_leftPanel__DrqiS","rightPanel":"styles_rightPanel__rB7IB","searchRow":"styles_searchRow__UBnw2"};